export default "__VITE_ASSET__DqoeQlpY__"